export const MIN_LANE_WIDTH = 240;
export const MIN_LANE_HEIGHT = 120;

// Default stroke color for connection edges (matches DEFAULT_LANE_COLOR — slate-400).
// Kept alongside layout constants so edge/lane/boundary association visuals share one source of truth.
export const DEFAULT_EDGE_STROKE = '#94a3b8';

// Byte conversion used by file-size limits. Named to avoid magic `1024` in validation paths.
export const BYTES_PER_MB = 1024 * 1024;
